import {OnfidoVerificationComponent} from "./onfido.verification.component";
import {OnfidoStatusBadgeComponent} from "./onfido.status-badge.component";
import {ONFIDO_VERIFICATION_RESULTS_COMPONENTS} from "./results/index";

export * from './onfido.verification.component';
export * from './results';

export const ONFIDO_VERIFICATION_COMPONENTS = [
    OnfidoVerificationComponent,
    OnfidoStatusBadgeComponent,
    ONFIDO_VERIFICATION_RESULTS_COMPONENTS
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/onfido/index.ts